export default {
  darkBlue: '#1f2b3b',
  lightBlue: '#324359',
  white: '#ffffff',
  grey: '#808080',
  yellow: '#ff8a00'
}
